import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { DictionaryResponse } from '../../lib'

export type Params = (api_end_point: typeof API_END_POINTS.dictionary) => string

export type EndPoints = typeof API_END_POINTS.dictionary

const get = async (cb: Params) => {
  return await api.json<DictionaryResponse[]>(cb(API_END_POINTS.dictionary))
}

export default get
